import { Head, Link, useForm } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import AuthLayout from "@/layouts/auth-layout"
import { newUserSessionPath, userPasswordPath } from "@/routes"

export default function NewPasswordReset() {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: "",
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(userPasswordPath())
  }

  return (
    <AuthLayout title="" description="">
      <Head title="Reset password" />
      <div className="flex w-full flex-col gap-6">
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Reset password</CardTitle>
            <CardDescription>
              Enter the email address associated with your account and
              we&apos;ll send you a link to reset your password
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <FieldGroup>
                <Field>
                  <FieldLabel htmlFor="email">Email</FieldLabel>
                  <Input
                    id="email"
                    type="email"
                    name="user[email]"
                    placeholder="email@example.com"
                    value={data.user.email}
                    onChange={(e) =>
                      setData("user", {
                        ...data.user,
                        email: e.target.value,
                      })
                    }
                    required
                    autoFocus
                  />
                  {errors["user.email"] && (
                    <FieldError>{errors["user.email"]}</FieldError>
                  )}
                </Field>
                <Field>
                  <Button type="submit" className="w-full" loading={processing}>
                    {processing ? "Sending..." : "Send email"}
                  </Button>
                </Field>
              </FieldGroup>
            </form>
          </CardContent>
        </Card>
        <div className="flex justify-center">
          <Button variant="ghost" asChild className="flex items-center gap-2">
            <Link href={newUserSessionPath()}>
              <ArrowLeft className="h-4 w-4" />
              Back to login
            </Link>
          </Button>
        </div>
      </div>
    </AuthLayout>
  )
}
